import React from "react";
import svgData from "../../constants/utilities/svgData";
import { useNavigate } from "react-router-dom";
import '../commanComponents.css'

export default function BackButton() {
    const navigate = useNavigate()
  return (
    <div className={`d-flex gap-2 lightBlueColor align-items-center cursor-pointer backButton`} onClick={()=> navigate(-1)}>
      <p >back</p>
      <div>{svgData?.backButton}</div>
    </div>
  );
}
 